import { useTranslation } from 'react-i18next';
// assets
import { screen } from 'components/styles/variables';
import mailIcon from 'public/static/images/about_us/mail-icon.png';
import messageArrow from 'public/static/images/about_us/message-box-arrow.png';
import autolistModelBg from 'public/static/images/about_us/section-bg-wheel-light.jpg';
import { flexBoxFullWidthCSS } from 'components/styles';

function AutolistModel() {
  const { t } = useTranslation();
  return (
    <div className={`outer-container ${flexBoxFullWidthCSS.className}`}>
      <div className="background" />
      <div className="container">
        <div className="row">
          <div className="col-lg-offset-2 col-lg-8 col-md-offset-2 col-md-8 col-sm-offset-1 col-sm-10">
            <div className="message-container">
              <div className="message-inner-container description">
                <div className="message">
                  <ul>
                    <li>
                      <h2>{t('aboutUs.mission.theProblem')}</h2>
                      <p>{t('aboutUs.mission.theProblemText')}</p>
                    </li>
                    <li>
                      <h2>{t('aboutUs.mission.theApproach')}</h2>
                      <p>{t('aboutUs.mission.theApproachText')}</p>
                    </li>
                    <li>
                      <h2>{t('aboutUs.mission.theResults')}</h2>
                      <p>{t('aboutUs.mission.theResultsText')}</p>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="message-inner-container contact">
                <div className="message">
                  <div className="message-box">
                    <a href="/help" className="contact">
                      <img className="message-box-icon" src={mailIcon} />
                      <h3>{t('aboutUs.mission.contactUs')}</h3>
                      <p>{t('aboutUs.mission.contactUsText')}</p>
                      <img className="message-box-arrow" src={messageArrow} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {flexBoxFullWidthCSS.styles}
      <style jsx>{`
        .outer-container {
          position: relative;
          height: 660px;
        }

        @media (min-width: ${screen.smMin}) {
          .outer-container {
            height: 600px;
          }
        }

        .background {
          position: absolute;
          top: 0;
          background-color: black;
          background-image: url(${autolistModelBg});
          background-size: 1500px 750px;
          background-position: 103%;
          width: 100%;
          height: 100%;
        }

        @media (min-width: ${screen.smMin}) {
          .background {
            background-position: center top;
            background-position-y: -135px;
          }
        }

        .message-container {
          position: relative;
          top: 0;
          display: table;
          width: 100%;
          height: 660px;
        }

        @media screen and (min-width: ${screen.smMin}) {
          .message-container {
            height: 600px;
          }
        }

        .message-inner-container {
          width: 100%;
          display: block;
        }

        @media screen and (min-width: ${screen.smMin}) {
          .message-inner-container {
            width: 50%;
            display: table-cell;
            vertical-align: middle;
            text-align: center;
          }
        }

        .message-inner-container.description {
          padding: 20px 0 0 0;
        }

        @media screen and (min-width: ${screen.smMin}) {
          .message-inner-container.description {
            padding: 0 15px 0 0;
          }
        }

        @media screen and (min-width: ${screen.smMin}) {
          .message-inner-container.contact {
            padding: 0 0 0 15px;
          }
        }

        .message {
          color: white;
          font-size: 21px;
          padding: 5px 0;
          width: 100%;
        }

        @media screen and (min-width: ${screen.smMin}) {
          .message {
            font-size: 24px;
          }
        }

        .message-box {
          border: 2px solid #fff;
          border-radius: 50px;
          position: relative;
          width: 100%;
          height: 100px;
        }

        .message-box-icon {
          position: absolute;
          top: 32px;
          left: 39px;
          width: 48px;
        }

        .message-box-arrow {
          position: absolute;
          right: 18px;
          top: 39px;
          width: 12px;
        }

        .message-box p {
          position: absolute;
          top: 28px;
          left: 110px;
          font-size: 15px;
          text-transform: none;
          text-align: left;
          color: white;
          display: none;
        }

        @media screen and (min-width: ${screen.smMin}) {
          .message-box p {
            display: block;
            width: 140px;
            margin: 0;
            top: 39px;
          }
        }

        @media screen and (min-width: ${screen.lgMin}) {
          .message-box p {
            width: 165px;
          }
        }

        .message-box h3 {
          position: absolute;
          left: 110px;
          font-size: 24px;
          font-weight: 600;
          text-transform: none;
          color: white;
          top: 6px;
        }

        @media screen and (min-width: ${screen.smMin}) {
          .message-box h3 {
            margin: 0;
            top: 13px;
            font-size: 18px;
          }
        }

        p {
          font-size: 15px;
          text-transform: none;
          text-align: left;
        }

        ul {
          padding: 0;
          margin: 0;
          list-style-type: none;
        }

        li {
          margin-bottom: 25px;
          text-align: left;
        }

        li:last-child {
          margin-bottom: 0;
        }

        li h2 {
          margin: 0 0 15px 0;
          font-size: 24px;
          line-height: 24px;
          text-transform: none;
          font-weight: 600;
        }

        li p {
          font-size: 17px;
          text-transform: none;
          padding: 0 0 10px 0;
          margin: 0;
        }
      `}</style>
    </div>
  );
}

export default AutolistModel;
